import React, { Component } from "react";
import TableModal from "../../UI/TableModal";
import {
  isSet,
  isObject,
  IsJsonString,
} from "../../../Utils/CommonFunctions";
import http from "../../../services/http";
import Wrp from "../../../hoc/Wrp/Wrp";
import PagesServices from "../../../services/PagesServices";
import { extractConfigAttributes } from "../../../Containers/PagesContainer/PagesContainerUtils";
import { connect } from 'react-redux';
import * as actions from '../../../store/actions';

class PagesMultiLookupModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: this.props.isModalOpen,
      status: null,
      isConfirmPage: false,
      tableRecords: {
        tableHead: [],
        tableData: {
          data: [],
          status: 200
        },
        pagination: {
          page: 0,
          orderBy: '',
          perPage: 10,
          direction: 'ASC',
          totalRecords: 0,
          search: ''
        }
      },
      selectedRows: [], // Array of rowIds that are selected
      // Pages API state
      pageConfig: null,
      inputVariables: [],
      outputVariables: [],
      pageConfigId: null,
      config: null,
    }
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.isModalOpen !== this.props.isModalOpen) {
      this.setState({ isModalOpen: this.props.isModalOpen });
      if (this.props.isModalOpen === true) {
        // Initialize selected rows from props when modal opens
        if (this.props.selectedValue) {
          this.initializeSelectedRows(this.props.selectedValue.map(item=>item.id));
        }
        
        // Initialize config if not already set
        if (!this.state.config && this.props.childrenProps) {
          const config = extractConfigAttributes(this.props.childrenProps);
          if (config) {
            this.setState({ config }, () => {
              if (config.apiAction && config.apiAction.trim() !== "") {
                this.fetchPageConfigAndVariables(config.apiAction, () => {
                  this.LayoutsFormsList(this.state.tableRecords.pagination, true);
                });
              } else {
                this.LayoutsFormsList(this.state.tableRecords.pagination, true);
              }
            });
          } else {
            this.LayoutsFormsList(this.state.tableRecords.pagination, true);
          }
        } else {
          this.LayoutsFormsList(this.state.tableRecords.pagination, true);
        }
      } else {
        // When modal closes, preserve selectedRows but don't clear them
        // They will be used when modal reopens
      }
    }
    
    // Update selectedRows if selectedValue prop changes
    if (prevProps.selectedValue !== this.props.selectedValue && this.props.selectedValue) {
      this.initializeSelectedRows(this.props.selectedValue.map(item=>item.id));
    }
  }

  componentDidMount = () => {
    // Initialize config from props
    if (this.props.childrenProps) {
      const config = extractConfigAttributes(this.props.childrenProps);
      if (config && config.apiAction && config.apiAction.trim() !== "") {
        this.setState({ config }, () => {
          this.fetchPageConfigAndVariables(config.apiAction);
        });
      }
    }
    // Initialize selected rows from props.selectedValue
    if (this.props.selectedValue) {
      this.initializeSelectedRows(this.props.selectedValue.map(item=>item.id));
    }
  }

  selectCheckbox = (e) => {
    const val = e.target.checked;
    // console.log('val',val);
    if (isSet(val,false) === true) {
      this.selectAllCheckbox(true);
    } else {

      const tableDataSel = { ...this.state.tableRecords };
      let selectedRows = [...this.state.selectedRows];
      tableDataSel.tableData.data.map((item,index)=>{
        tableDataSel.tableData.data[index].className=(this.props.isConfirmPage===false)?'selected':'';
            tableDataSel.tableData.data[index].isSelected=false;
            tableDataSel.tableData.data[index].data.Checkbox.checked=false;
           
            selectedRows = [...selectedRows].filter(rowId => rowId !== tableDataSel.tableData.data[index].rowId);
            // console.log('tableDataSel.tableData.data[index].rowId',tableDataSel.tableData.data[index].rowId,selectedRows);
            // this.props.removeSelectedMultiLookupAction(tableDataSel.tableData.data[index].rowId,this.props.item.id);
      })
      // console.log('tableDataSel',tableDataSel,selectedRows);
      this.setState({
        tableRecords: tableDataSel,
        selectedRows:selectedRows,          // optional but usually correct
      });
  
      // If you also expose tableRecords upward, call:
      // this.props.updateTableRecords && this.props.updateTableRecords(tableDataSel);
    }
  };
  initializeSelectedRows = (selectedValue) => {
    let valueArray = [];
    if (Array.isArray(selectedValue)) {
      valueArray = selectedValue.map(v => String(v));
    } else if (typeof selectedValue === 'string') {
      try {
        const parsed = IsJsonString(selectedValue) ? JSON.parse(selectedValue) : selectedValue;
        valueArray = Array.isArray(parsed) ? parsed.map(v => String(v)) : [String(parsed)];
      } catch (e) {
        valueArray = selectedValue.split(',').map(v => String(v.trim())).filter(v => v);
      }
    } else {
      valueArray = [String(selectedValue)];
    }
    this.setState({ selectedRows: valueArray });
  }

  // Fetch page config and input/output variables once
  fetchPageConfigAndVariables = async (apiAction, callback, showLoader = false) => {
    try {
      // Show loader if requested
      if (showLoader && this.props.Loader) {
        this.props.Loader(true);
      }
      
      const pageConfigResponse = await PagesServices.getConfigByName(apiAction);
      
      if (pageConfigResponse && pageConfigResponse.code === 200 && pageConfigResponse.data) {
        const pageConfig = pageConfigResponse.data;
        const pageConfigId = pageConfig.id;
        const variablesResponse = await PagesServices.getConfigVariablesList(pageConfigId);
        
        if (variablesResponse && variablesResponse.code === 200 && variablesResponse.data) {
          const inputVariables = variablesResponse.data.content.filter(v => v.is_request === true);
          const outputVariables = variablesResponse.data.content.filter(v => v.is_response === true);
          
          this.setState({
            pageConfig,
            pageConfigId,
            inputVariables,
            outputVariables,
          }, () => {
            // Hide loader if it was shown
            if (showLoader && this.props.Loader) {
              this.props.Loader(false);
            }
            if (callback) callback();
          });
        } else {
          // Hide loader if it was shown
          if (showLoader && this.props.Loader) {
            this.props.Loader(false);
          }
          if (callback) callback();
        }
      } else {
        // Hide loader if it was shown
        if (showLoader && this.props.Loader) {
          this.props.Loader(false);
        }
        if (callback) callback();
      }
    } catch (error) {
      console.error('Error fetching page config and variables:', error);
      // Hide loader on error
      if (showLoader && this.props.Loader) {
        this.props.Loader(false);
      }
      if (callback) callback();
    }
  }

  LayoutsFormsList = async (pagination, loader = true) => {
    const { config, pageConfigId, inputVariables, pageConfig, outputVariables } = this.state;
    const { searchField, offset, limit, resultVar, recordIdField, resultFields, totalRecordVar } = config || {};
    
    if (!config || !config.apiAction || config.apiAction.trim() === "") {
      console.warn('No API action configured');
      return;
    }

    // Show loader during API call
    if (loader===true) {
      this.props.Loader(true);
    }

    this.setState({
      tableRecords: {
        ...this.state.tableRecords,
        pagination: pagination
      }
    });

    const page = pagination.page || 0;
    const perPage = pagination.perPage || 10;
    const search = pagination.search || "";

    try {
      // Ensure we have page config and variables
      let currentPageConfigId = pageConfigId;
      let currentInputVariables = inputVariables;
      let currentPageConfig = pageConfig;
      
      if (!currentPageConfigId || !currentInputVariables || currentInputVariables.length === 0 || !currentPageConfig) {
        await this.fetchPageConfigAndVariables(config.apiAction);
        currentPageConfigId = this.state.pageConfigId;
        currentInputVariables = this.state.inputVariables;
        currentPageConfig = this.state.pageConfig;
      }

      if (!currentPageConfigId || !currentInputVariables || currentInputVariables.length === 0 || !currentPageConfig) {
        console.error('Failed to get page config or variables');
          this.props.Loader(false);
        return;
      }

      // Get from_page_mapping from config (similar to PagesRenderComponent pattern)
      const fromMapping = currentPageConfig.from_page_mapping || [];
      
      // Create inputMap similar to PagesRenderComponent
      const inputMap = Object.fromEntries(
        currentInputVariables.map(item => [item.id, item.api_name])
      );

      // Build payload using from_page_mapping (similar to PagesRenderComponent)
      const payload = fromMapping.map(item => {
        const apiName = isSet(item?.pages_variable_name, inputMap[item.pages_variable_id]);
        
        let selectedValue = '';
        // Handle special fields from config
        if (apiName === searchField) {
          selectedValue = decodeURIComponent(search);
        } else if (apiName === offset) {
          selectedValue = page.toString();
        } else if (apiName === limit) {
          selectedValue = perPage.toString();
        }
        
        return {
          ...item,
          selected_value: isSet(selectedValue, ''),
        };
      });

      const API_URL = `pageconfig/${currentPageConfigId}/pages-config-execute`;
      const response = await http.POST(API_URL, payload);

      // Hide loader after API call completes
        this.props.Loader(false);
      if (response.status === 200) {
        const responseData = response.data;
        if (responseData.code === 200) {
          const responseVariables = responseData.data?.variables || [];
          const currentPageConfig = this.state.pageConfig;
          const currentOutputVariables = this.state.outputVariables;
          
          if (responseVariables && responseVariables.length > 0 && resultVar && currentPageConfig) {
            // Map response variables using to_page_mapping
            const toPageMapping = currentPageConfig.to_page_mapping || [];
            const variableMapping = {};
            
            toPageMapping.forEach((toMap) => {
              if (toMap.field_mappings && Array.isArray(toMap.field_mappings)) {
                toMap.field_mappings.forEach((mField) => {
                  if (mField.automation_variable_id && mField.pages_variable_name) {
                    variableMapping[mField.automation_variable_id] = mField.pages_variable_name;
                  }
                });
              }
            });
            
            const responseVariableMap = {};
            responseVariables.forEach((responseVar) => {
              const pageVariableName = variableMapping[responseVar.id];
              if (pageVariableName) {
                responseVariableMap[pageVariableName] = responseVar;
              }
            });
            
            const resultVariable = responseVariableMap[resultVar];
            
            if (resultVariable) {
              let resRecordsData = [];
              try {
                const recordsData = isSet(resultVariable.value, resultVariable.selected_value);
                resRecordsData = IsJsonString(recordsData) ? JSON.parse(recordsData) : recordsData;
                
                if (!Array.isArray(resRecordsData)) {
                  resRecordsData = resRecordsData ? [resRecordsData] : [];
                }
                
                // Total records: from totalRecordVar in API response if configured, else current page length
                let totalRecords = resRecordsData.length;
                if (totalRecordVar) {
                  const totalRecordVariable = responseVariableMap[totalRecordVar];
                  if (totalRecordVariable) {
                    const totalVal = isSet(totalRecordVariable.value, totalRecordVariable.selected_value);
                    const num = parseInt(totalVal, 10);
                    if (!Number.isNaN(num) && num >= 0) totalRecords = num;
                  }
                }
                
                // Build table structure - preserve selectedRows when rebuilding
                const currentSelectedRows = this.state.selectedRows || [];
                const tableHead = this.buildTableHead(resRecordsData, resultFields, recordIdField, currentSelectedRows);
                const tableData = this.buildTableData(resRecordsData, tableHead, recordIdField, currentSelectedRows);
                
                this.setState({
                  status: 200,
                  tableRecords: {
                    tableHead,
                    tableData: {
                      data: tableData,
                      status: 200
                    },
                    pagination: {
                      ...pagination,
                      totalRecords
                    }
                  },
                  // Preserve selectedRows
                  selectedRows: currentSelectedRows
                });
              } catch (error) {
                console.error('Error parsing records data:', error);
                this.setState({
                  status: 200,
                  tableRecords: {
                    tableData: { data: [], status: 400 },
                    tableHead: this.state.tableRecords.tableHead,
                    pagination: { ...pagination, totalRecords: 0 }
                  }
                });
              }
            }
          }
        }
      }
    } catch (error) {
      console.error('Modal records API error:', error);
      // Hide loader on error if it was shown
      if (loader === true) {
        this.props.Loader(false);
      }
      if (this.props.failMessage) {
        this.props.failMessage("Something went wrong...");
      }
    }
  }

  // Helper function to get nested property value
  getNestedValue = (obj, path) => {
    if (!obj || !path) return undefined;
    const keys = path.split('.');
    let value = obj;
    for (const key of keys) {
      if (value === null || value === undefined) {
        return undefined;
      }
      value = value[key];
    }
    return value;
  };

  // Build table head from records - if resultFields exist, use only those; otherwise use all fields
  buildTableHead = (records, resultFields, recordIdField, selectedRowsOverride = null) => {
    const selectedRows = selectedRowsOverride !== null ? selectedRowsOverride : this.state.selectedRows;
    // Check if all current page records are selected
    const allSelected = records.length > 0 && records.every((record) => {
      const recordId = recordIdField && recordIdField.includes('.')
        ? this.getNestedValue(record, recordIdField)
        : record[recordIdField] || record.id;
      return selectedRows.includes(String(recordId));
    });
    
    const tableHead = [
      {
        name:'',
        type:"Checkbox",
        columnName:"",
        isShow:true,
        clickHandler : (e)=> this.selectCheckbox(e),
        checked:false,
        attributes:{style:{width: "30px"}}
      }
      // {
      //   id: 'checkbox',
      //   type: "Checkbox",
      //   columnId: "",
      //   isShow: true,
      //   attributes: { style: { width: "30px" } },
      //   checked: allSelected,
      //   clickHandler: (e) => {
      //     e.stopPropagation();
      //     this.selectAllCheckbox(!allSelected);
      //   }
      // }
    ];

    if (!records || records.length === 0) {
      return tableHead;
    }

    const firstRecord = records[0];
    
    if (resultFields && resultFields.length > 0) {
      // Use only fields specified in Field tags (supports nested paths like "country.name")
      resultFields.forEach((field) => {
        tableHead.push({
          name: field.label || field.key,
          type: "HyperLink",
          columnId: field.key,
          isShow: true,
        });
      });
    } else {
      // Use all direct fields from the record (excluding nested objects)
      Object.keys(firstRecord).forEach((key) => {
        const value = firstRecord[key];
        if (value !== null && value !== undefined && 
            (typeof value !== 'object' || (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length < 10))) {
          tableHead.push({
            name: key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
            type: "HyperLink",
            columnId: key,
            isShow: true,
          });
        }
      });
    }

    return tableHead;
  };

  // Build table data from records
  buildTableData = (records, tableHead, recordIdField, selectedRowsOverride = null) => {
    const tableData = [];
    const selectedRows = selectedRowsOverride !== null ? selectedRowsOverride : this.state.selectedRows;
    const { config } = this.state;
    const defaultField = config?.defaultField; // Get defaultField from config

    records.forEach((record, index) => {
      // Get record ID (supports nested path if recordIdField contains dots)
      const recordId = recordIdField && recordIdField.includes('.')
        ? this.getNestedValue(record, recordIdField)
        : record[recordIdField] || record.id;
      const recordIdString = String(recordId);
      
      const fieldsRow = {
        Checkbox: {
          checked: selectedRows.includes(recordIdString),
          name: 'windowCheckbox',
          // Checkbox component calls: changeHandler(colData, colData.attributes)
          // Following FormBuilder pattern - ignore parameters and call directly with rowId
          changeHandler: () => {
            this.onChangeSelectLookup(recordIdString);
          }
        }
      };

      // Add data for each column (supports nested paths like "country.name")
      tableHead.forEach((column) => {
        if (column.columnId && column.columnId !== '') {
          // Get field value (supports both direct and nested paths)
          const fieldValue = column.columnId.includes('.')
            ? this.getNestedValue(record, column.columnId)
            : record[column.columnId];
          
          // Check if this column matches the defaultField from config
          const isDefaultDisplay = defaultField ? (column.columnId === defaultField) : false;
          
          fieldsRow[column.columnId] = {
            className: isDefaultDisplay ? 'primary_color cursor-pointer' : 'cursor-pointer',
            isDefaultDisplay: isDefaultDisplay,
            value: fieldValue !== undefined && fieldValue !== null ? String(fieldValue) : ''
          };
        }
      });

      tableData.push({
        clickHandler: (e) => {
          // Don't process row click if clicking on checkbox or input
          if (e && e.target && (e.target.type === 'checkbox' || e.target.tagName === 'INPUT')) {
            return;
          }
          this.onChangeSelectLookup(recordIdString);
        },
        className: selectedRows.includes(recordIdString) ? 'selected' : '',
        rowId: recordIdString,
        isSelected: selectedRows.includes(recordIdString),
        data: fieldsRow
      });
    });

    return tableData;
  };

  onChangeSelectLookup = (rowId)=>{
    const tableDataSel = this.state.tableRecords;
    let selectedRows = [...this.state.selectedRows];
    if(isSet(tableDataSel.tableHead[0].checked===true,false)===true){
      tableDataSel.tableHead[0].checked=false;
      }
    tableDataSel.tableData.data.map((item,index)=>{
        if(item.rowId===rowId){
          // const columnId = tableDataSel.tableHead[1].columnName;
          let isChecked;
          isChecked = tableDataSel.tableData.data[index].data.Checkbox.checked;
          tableDataSel.tableData.data[index].className=(isChecked)? '':'selected';
          tableDataSel.tableData.data[index].isSelected=(isChecked)? false:true;
          tableDataSel.tableData.data[index].data.Checkbox.checked=(isChecked)? false:true;

          if(tableDataSel.tableData.data[index].data.Checkbox.checked){
            selectedRows.push(rowId);
          }else{
            selectedRows = [...selectedRows].filter(rowId => rowId !== rowId);
              
          }
        }
    });
    // console.log('selectedRowscheck',selectedRows);
    this.setState({
      tableRecords: tableDataSel,
      selectedRows:selectedRows,
    });
      // this.updateTableRecords(tableDataSel);
    }
  selectAllCheckbox = (isChecked) => {
    // const tableDataSel = { ...this.state.tableRecords };
    let selectedRows = [...this.state.selectedRows];
    const newTableRecord = this.state.tableRecords;
    let hasValidation =false;
    let selectedCnt =0;
    newTableRecord.tableData.data.map((item,index)=>{
      const tableData = newTableRecord.tableData.data[index].data;
      
        if(tableData.Checkbox.checked!==isChecked){
          newTableRecord.tableData.data[index].className=(this.props.isConfirmPage===false)?'selected':'';
         newTableRecord.tableData.data[index].isSelected=true;
          newTableRecord.tableData.data[index].data.Checkbox.checked=isChecked;
           if(isChecked===true){
              selectedCnt++;
              selectedRows.push(newTableRecord.tableData.data[index].rowId);
            //  this.props.addSelectedMultiLookupAction(newTableRecord.tableData.data[index],this.props.item.id);
            }else{
              selectedRows = [...selectedRows].filter(rowId => rowId !== newTableRecord.tableData.data[index].rowId);
              // this.props.removeSelectedMultiLookupAction(newTableRecord.tableData.data[index].rowId,this.props.item.id);
            }
            Object.entries(tableData).map(([key, column]) => {
              if(Object.keys(isSet(column.item,{})).length>0){
                  newTableRecord.tableData.data[index].data[key] = item.data[key];
              }  
            })
         }
     })
     console.log('selectedRows',selectedRows);
    if(isChecked===true && hasValidation===false){
      newTableRecord.tableHead[0].checked=true;
     }
    if(isChecked===false){
      newTableRecord.tableHead[0].checked=false;
    }  

    this.setState({
      tableRecords: newTableRecord,
    },()=>{
      this.setState({selectedRows:selectedRows});
      // console.log('selectedRows',selectedRows);
    });
    // console.log('newTableRecord',newTableRecord);
    // const isSelectedall = newTableRecord.pagination.totalRecords==(selectedCnt+Number(isSet(this.props.selectedMultiLookup[this.props.item.id],[]).length,isChecked));
    
  };

  confirmMultiLoopupModalHandler = () => {
    const { selectedRows, tableRecords } = this.state;
    
    if (selectedRows.length === 0) {
      if (this.props.failMessage) {
        this.props.failMessage("Please select at least one record");
      }
      return;
    }

    const lookupDataArray = [];
    // console.log('selectedRows',selectedRows);
    selectedRows.forEach((rowId) => {
      const selectedRow = tableRecords.tableData.data.find(item => item.rowId === rowId);
      if (selectedRow) {
        let displayName = [];
        let defaultDisplay = [];
        
        tableRecords.tableHead.forEach((column) => {
          const colId = column.columnId;
          if (colId && selectedRow.data[colId]) {
            const selectedItem = selectedRow.data[colId];
            const selectedValue = selectedItem.value;
            if (isObject(selectedValue) === true) { return false; }
            if (selectedValue !== '' && selectedValue !== undefined && selectedValue !== null) {
              displayName.push(selectedValue);
              if (selectedItem.isDefaultDisplay === true && defaultDisplay.length < 2) {
                defaultDisplay.push(selectedValue);
              }
            }
          }
        });
        
        const endPos = (tableRecords.tableHead.length <= 2) ? tableRecords.tableHead.length : 2;
        const finalDisplayName = (defaultDisplay.length === 0) ? displayName.slice(0, endPos) : defaultDisplay;
        
        lookupDataArray.push({
          label: finalDisplayName.join(' '),
          text: finalDisplayName.join(' '),
          value: rowId,
          id: rowId,
        });
      }
    });
    
    if (this.props.setMultiLookupValuesFromList) {
      this.props.setMultiLookupValuesFromList(lookupDataArray);
    }
  };

  cancelLoopupModalHandler = () => {
    if (this.props.cancelMultiLoopupModalHandler) {
      this.props.cancelMultiLoopupModalHandler();
    }
  }

  recordsChangeHandler = (pagination) => {
    this.LayoutsFormsList(pagination, true); // Show loader during API call
  }

  render() {
    const windowName = this.props.windowName || 'Record';
    const ModalTitle = "Select " + windowName;
    const modalType = 'tableList';
    const { selectedRows } = this.state;
    // console.log('selectedRows-11',selectedRows);
    const modalButtonList = [
      {
        attributes: {
          className: "btn btn-cancel",
          "data-dismiss": "modal",
          "id": "closeMultiLookupModal",
        },
        clickHandler: this.cancelLoopupModalHandler,
        name: "Cancel"
      }
    ];
    
    const FooterButtonList = [
      {
        attributes: {
          className: "btn primary_bg cursor-pointer",
          "data-dismiss": "modal",
        },
        disabled: (selectedRows.length > 0) ? false : true,
        clickHandler: this.confirmMultiLoopupModalHandler,
        name: "Confirm"
      }
    ];
    
    try {
      return (
        <Wrp>
          <TableModal
            isModalOpen={this.state.isModalOpen}
            title={ModalTitle}
            modalType={modalType}
            buttonList={modalButtonList}
            tableRecords={this.state.tableRecords}
            FooterButtonList={FooterButtonList}
            recordsChangeHandler={this.recordsChangeHandler}
            isConfirmPage={this.state.isConfirmPage}
            selectAllTableData={this.selectAllCheckbox}
            selectedMultiLookupCount={selectedRows.length}
          />
        </Wrp>
      )
    } catch (e) {
      console.error('MultiLookupModal render error:', e);
      if (this.props.failMessage) {
        this.props.failMessage("Something went wrong...");
      }
    }
  }
}

const mapDispatchToProps = dispatch => {
  return {
    Loader: (bool) => dispatch(actions.loader(bool)),
    succMessage: (msg) => dispatch(actions.succMessage(msg)),
    failMessage: (msg) => dispatch(actions.failMessage(msg)),
  };
};

export default connect(
  null,
  mapDispatchToProps
)(PagesMultiLookupModal);

